import { LogoTypeNames, RectangularName, SquareName } from "@timesheets/constants-common";

import { IState } from "./IState";
import { MutationTree } from "vuex";
import Vue from "vue";
import { WireEntities } from "@timesheets/common";
import { getLogoPathFromType } from "../utils";

export const mutations: MutationTree<IState> = {
  setCurrentSession(state, session: WireEntities.Session.ISession) {
    state.currentSession = session;
  },
  setLoggedOut(state) {
    (state.currentSession.account as { isLoggedIn: boolean }).isLoggedIn = false;
  },
  mutateCurrentSessionProperties(state, { isEnabled, emailAddress, fullname }: { isEnabled?: boolean; emailAddress?: string; fullname?: string }) {
    const account = state.currentSession.account as { isEnabled: boolean; emailAddress: string; fullname: string };
    if (typeof isEnabled === "boolean") {
      account.isEnabled = isEnabled;
    }

    if (typeof fullname === "string") {
      account.fullname = fullname;
    }

    if (typeof emailAddress === "string") {
      account.emailAddress = emailAddress;
    }
  },
  setLogoTimestamp(state, { timestamp, logoType, tenantName }: { timestamp: number; logoType: LogoTypeNames; tenantName: string }) {
    let logoPath = getLogoPathFromType(logoType, tenantName);

    if (timestamp) {
      logoPath += "?timestamp=" + timestamp;
    }

    let logoPaths = state.logoPaths[tenantName];
    if (!logoPaths) {
      state.logoPaths[tenantName] = logoPaths = Vue.set(state.logoPaths, tenantName, { [RectangularName]: "", [SquareName]: "" });
    }

    logoPaths[logoType] = logoPath;
  },
};
